module.exports = __webpack_public_path__ + "static/media/ic_dth.c0293ed1.png";